module.exports = __webpack_public_path__ + "static/cdhs-f95341875c7d5d87eaa8496932a4a880.png";